<div class="modal-wrapper">
  <div class="modal-background" (click)="visitsService.closeModal()"></div>
  <div class="modal-window">
    <router-outlet></router-outlet>
  </div>
</div>
